<template>
  <svg version="1.1" id="Layer_1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" x="0px" y="0px"
    viewBox="0 0 200 200" enable-background="new 0 0 200 200" xml:space="preserve">
  <g>
    <path class="color" fill="#F45B5B" d="M131.706,125.045c-2.67-2.663-5.656-4.933-8.864-6.79c12.807-7.8,21.404-21.898,21.404-37.907
      C144.246,55.956,124.289,36,99.898,36S55.551,55.956,55.551,80.348c0,16.471,9.107,30.909,22.528,38.556
      c-2.798,1.731-5.417,3.78-7.784,6.142c-0.5,0.5-0.918,1.051-1.271,1.629c-6.931,7.667-11.153,17.829-11.153,28.979
      c0,4.774,3.871,8.646,8.646,8.646s8.646-3.871,8.646-8.646c0.006-6.877,2.743-13.47,7.609-18.329
      c5.111-4.85,11.666-7.285,18.229-7.31c6.562,0.024,13.118,2.46,18.229,7.31c4.866,4.859,7.603,11.452,7.608,18.329
      c0,4.774,3.871,8.646,8.646,8.646c4.774,0,8.646-3.871,8.646-8.646c0-11.148-4.223-21.311-11.152-28.977
      C132.624,126.097,132.207,125.546,131.706,125.045z M99.899,52.564c15.28,0,27.783,12.502,27.783,27.784
      c0,15.28-12.503,27.782-27.783,27.782c-15.281,0-27.784-12.502-27.784-27.782C72.115,65.066,84.618,52.564,99.899,52.564z"/>
    <path fill="#FFFFFF" d="M99.899,108.131c15.28,0,27.783-12.502,27.783-27.782c0-15.282-12.503-27.784-27.783-27.784
      c-15.281,0-27.784,12.502-27.784,27.784C72.115,95.629,84.618,108.131,99.899,108.131z"/>
  </g>
  </svg>

</template>

<script>
export default {
  name: 'UserIcon'
}
</script>
